import React from "react"
import { graphql } from "gatsby"
import Layout from '../../components/layout';
import BlogContainer from '../../components/blog-container';
import AllPostsLink from '../../components/common/all-posts-link';

export default ({ data }) => {
  const post = data.markdownRemark
  return (
    <Layout title={post.frontmatter.title}>
      <BlogContainer
        nav={
          <AllPostsLink/>
        }
        headerLink="/blog"
        >
        <article>
          <header>
            <h2>{post.frontmatter.title}</h2>
          </header>
          <main dangerouslySetInnerHTML={{ __html: post.html }} />
        </article>
      </BlogContainer>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { finalSlug: { eq: $slug } }) {
      html
      frontmatter {
        title
      }
    }
  }
`